import { render, staticRenderFns } from "./OnlineWorkshop.vue?vue&type=template&id=068bd874&scoped=true&"
import script from "./OnlineWorkshop.vue?vue&type=script&lang=js&"
export * from "./OnlineWorkshop.vue?vue&type=script&lang=js&"
import style0 from "./OnlineWorkshop.vue?vue&type=style&index=0&id=068bd874&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068bd874",
  null
  
)

export default component.exports